const localStorageAuthKeyName = 'suppliers_auth'
export const storeAuthToLocalStorage = (token: string) => {
  localStorage.setItem(localStorageAuthKeyName, token)
}
export const getAuthFromLocalStorage = () =>
  localStorage.getItem(localStorageAuthKeyName)

export const removeAuthFromLocalStorage = () => {
  localStorage.removeItem(localStorageAuthKeyName)
}
